export const toolbarTheme = {
  defaultStyles: {
    display: 'flex',
    alignItems: 'center',
  },
  gutters: {
    paddingLeft: 42,
    paddingRight: 42,
  },
  large: {
    minHeight: 92,
  },
  normal: {
    minHeight: 64,
  },
  dense: {
    minHeight: 46,
  },
};
